<div class="fluid grid">

  <div class="col-12">
    <h5>Способ оплаты: <span style="font-weight:600">{{selectedPayType.DOCNAME1}}</span></h5>
    <p-selectButton [options]="payTypes" [(ngModel)]="newDocument.DOCTYPE" optionValue="DOCTYPEID" optionLabel="DOCNAME1" (onChange)="onDocTypeChanges($event)"></p-selectButton>
  </div>

  <div class="col-12">
    <h5>Сумма платежа: {{paymentSumInMc | number:'1.0-2'}}</h5>
    <input type="number" pInputText [(ngModel)]="paymentSumInMc" (input)="onInputMc($event)" (change)="onChangeMc($event)" step="0.01" [style]="{'width':'100%', 'text-align':'center'}" />
    <p-slider [(ngModel)]="paymentSumInMc" [max]="(totalSumInMc - paidBeforeSumInMc)" (onSlideEnd)="onSlideEndMc($event)"></p-slider>
  </div>

  <div class="col-12">
    <h5>Всего оплачено: {{expectedSumInMc | number:'1.0-2'}} из {{totalSumInMc | number:'1.0-2'}} Осталось: {{(totalSumInMc - paidBeforeSumInMc - paymentSumInMc) | number:'1.0-2'}} </h5>
    <input type="number" pInputText [(ngModel)]="expectedSumInMc" (input)="onInputEx($event)" (change)="onChangeEx($event)" step="0.01" [style]="{'width':'100%', 'text-align':'center'}" readonly />
    <p-slider [(ngModel)]="expectedSumInMc" [min]="0" [max]="totalSumInMc" (onSlideEnd)="onSlideEndEx($event)" disabled></p-slider>
  </div>

  <div class="col-6" hidden>
    <h5>Валюта: {{paymentSumInBc | number:'1.0-2'}}</h5>
    <input type="number" pInputText [(ngModel)]="paymentSumInBc" (input)="onInputBc($event)" (change)="onChangeBc($event)" />
    <p-slider [(ngModel)]="paymentSumInBc" (onSlideEnd)="onSlideEndBc($event)"></p-slider>
  </div>

  <div class="col-12">
    <h5>В %: {{expectedSumInPc | number:'1.0-0'}}%</h5>
    <input type="number" pInputText [(ngModel)]="expectedSumInPc" (input)="onInputPc($event)" step="5.0" (change)="onChangePc($event)" [style]="{'width':'100%', 'text-align':'center'}" />
    <p-slider [(ngModel)]="expectedSumInPc" (onSlideEnd)="onSlideEndPc($event)"></p-slider>
  </div>

</div>
